import { GraphQLClient } from "graphql-request"
import { getSdk } from "../api.graphql.generated"

const apiClient = new GraphQLClient(process.env.GATSBY_API_ENDPOINT || "not-set", {
  headers: {},
})

const api = getSdk(apiClient)
export { apiClient, api }
